import { string } from 'prop-types';
import { Field } from 'react-final-form';

import { Radio } from '@olist/united';

const SignupRadio = ({ label, ...props }) => {
  return (
    <Field {...props} type="radio">
      {({ input }) => <Radio {...input} {...props} label={label} />}
    </Field>
  );
};

SignupRadio.propTypes = {
  label: string.isRequired,
  name: string.isRequired,
  value: string.isRequired,
};

export default SignupRadio;
